import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ordersService } from '../services/orders.service';
import type { SellerRefundPayload } from '../refund/seller-refund-reasons';

export function useRefundOrder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ orderId, body }: { orderId: string; body: SellerRefundPayload }) =>
      ordersService.refundOrder(orderId, body),
    onSuccess: (_, { orderId }) => {
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      queryClient.invalidateQueries({ queryKey: ['order', orderId] });
      toast.success('Remboursement effectué');
    },
    onError: () => {
      toast.error('Erreur lors du remboursement');
    },
  });
}
